export const getFileType = string => /(?:\.([^.]+))?$/.exec(string)[1];

export const getFileSize = size => {
  if (typeof size === 'string') return size;

  let fileSize;
  if (size >= 1000 && size < 1000000) {
    fileSize = `${Math.round(size / 1000)} KB`;
  } else if (size >= 1000000 && size < 1000000000) {
    fileSize = `${Math.round(size / 1000000)} MB`;
  } else if (size >= 1000000000) {
    fileSize = `${Math.round(size / 1000000000)} GB`;
  }

  return fileSize;
};

export const getRandomItemFromArray = array => array[Math.floor(Math.random() * array.length)];

export const getRandomNumber = (min, max) => Math.round(Math.random() * (max - min) + min);

export const buildSizes = sizes => {
  let sizesString = '';

  sizes.forEach(size => {
    if (size.condition) {
      sizesString += `(${size.condition}) `;
    }
    sizesString += `${size.width}, `;
  });
  return sizesString.replace(/,\s*$/, '');
};

export const buildSrcSet = srcset => {
  let srcsetString = '';
  srcset.forEach(src => {
    if (src.suffix) {
      srcsetString += `${src.src} ${src.suffix}, `;
    } else {
      srcsetString += `${src.src}, `;
    }
  });
  return srcsetString.replace(/,\s*$/, '');
};

export const truncateString = (str, length = 200) => {
  if (str.length <= length) {
    return str;
  }
  return `${str.substring(0, length)} ...`;
};

export const isPeriod = (startDate, endDate) => {
  return (
    `${startDate.d}. ${startDate.m} ${startDate.Y}` !== `${endDate.d}. ${endDate.m} ${endDate.Y}`
  );
};
export const getTimeName = time => {
  let timeName = 'present';

  if (time === 'was-war' || time === 'what-was') {
    timeName = 'past';
  } else if (time === 'was-kommt' || time === 'what-will-be') {
    timeName = 'future';
  }

  return timeName;
};

export const removeTrailingSlash = string => (string !== '/' ? string.replace(/\/$/, '') : string);

export const getLanguage = data =>
  typeof data !== 'undefined' && typeof data.lang !== 'undefined' ? data.lang : 'de';

export const padStart = (targetLength, target, padString = '0') => {
  const strTarget = target.toString();

  return targetLength > strTarget.length
    ? `${Array(targetLength - strTarget.length)
        .fill(padString)
        .toString()}${strTarget}`
    : strTarget;
};

export const formatTime = (seconds, preserveHours = false) => {
  const hh = padStart(2, Math.floor(seconds / 3600) % 24);
  const mm = padStart(2, Math.floor(seconds / 60) % 60);
  const ss = padStart(2, Math.floor(seconds % 60));

  return hh > 0 || preserveHours ? `${hh}:${mm}:${ss}` : `${mm}:${ss}`;
};

export const isInViewport = element => {
  const bounding = element.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const myFuturiumMap = (slug, value) => {
  const defaultMap = {
    mensch: {
      name: 'human',
      color: '#ABDCEC',
      altColor: '#cfe6ee',
      darkColor: '#202E5C'
    },
    technik: {
      name: 'technic',
      color: '#AAAEB2',
      altColor: '#e1e1e1',
      darkColor: '#394750'
    },
    natur: {
      name: 'nature',
      color: '#6DAC9D',
      altColor: '#6dab9c',
      darkColor: '#406562'
    },
    'archiv-2': {
      name: 'archive',
      color: '#F1F1F1',
      altColor: '#f1f1f1',
      darkColor: '#3E3E3E'
    }
  };

  const extendedMap = {
    ...defaultMap,
    people: defaultMap.mensch,
    technology: defaultMap.technik,
    human: defaultMap.mensch,
    technic: defaultMap.technik,
    nature: defaultMap.natur,
    'archiv-2': defaultMap['archiv-2']
  };

  return extendedMap[slug][value];
};
